const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

const isYouTubeHostname = (hostname: string) => {
  const normalizedHostname = hostname.toLowerCase();
  return normalizedHostname === 'youtu.be'
    || normalizedHostname === 'youtube.com'
    || normalizedHostname.endsWith('.youtube.com')
    || normalizedHostname === 'youtube-nocookie.com'
    || normalizedHostname.endsWith('.youtube-nocookie.com');
};

export const getYouTubeVideoId = (value: string): string | null => {
  try {
    const url = new URL(value);
    if (!['http:', 'https:'].includes(url.protocol) || !isYouTubeHostname(url.hostname)) return null;

    const pathParts = url.pathname.split('/').filter(Boolean);
    let videoId: string | null = null;

    if (url.hostname.toLowerCase() === 'youtu.be') {
      videoId = pathParts[0] || null;
    } else if (pathParts[0] === 'watch') {
      videoId = url.searchParams.get('v');
    } else if (['embed', 'shorts', 'live', 'v'].includes(pathParts[0])) {
      videoId = pathParts[1] || null;
    }

    return videoId && VIDEO_ID_PATTERN.test(videoId) ? videoId : null;
  } catch {
    return null;
  }
};

export const getSafeYouTubeUrl = (value: string): string | null => {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && isYouTubeHostname(url.hostname) ? url.toString() : null;
  } catch {
    return null;
  }
};

export const getYouTubeEmbedUrl = (value: string): string | null => {
  const videoId = getYouTubeVideoId(value);
  return videoId ? `https://www.youtube-nocookie.com/embed/${videoId}?playsinline=1&rel=0` : null;
};
